/* eslint-disable react/prop-types */
import { useState, useRef, useEffect } from "react";

const TOOLTIP_TEXT =
  "Commute Score estimates general commuting convenience based on factors such as proximity to major roads and typical travel ranges. This proprietary score is provided for informational purposes only and is not an official government rating or third-party standard. Scores may not reflect actual traffic conditions, transit availability, commute times, or individual preferences.";

/**
 * ScoreTooltip - Renders an info icon that shows a tooltip/popover with
 * commuter score explanation text and a "Learn More" link.
 *
 * Shows on hover (desktop) and toggles on click (mobile).
 *
 * @param {Function} onLearnMoreClick - Optional callback for "Learn More" navigation.
 *   If not provided, defaults to scrolling to the FAQ section on the page.
 */
const ScoreTooltip = ({ onLearnMoreClick }) => {
  const [isVisible, setIsVisible] = useState(false);
  const tooltipRef = useRef(null);
  const hideTimeoutRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setIsVisible(false);
      }
    };

    if (isVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isVisible]);

  const handleToggle = () => {
    setIsVisible((prev) => !prev);
  };

  const handleMouseEnter = () => {
    if (hideTimeoutRef.current) {
      clearTimeout(hideTimeoutRef.current);
      hideTimeoutRef.current = null;
    }
    setIsVisible(true);
  };

  const handleMouseLeave = () => {
    hideTimeoutRef.current = setTimeout(() => {
      setIsVisible(false);
    }, 200);
  };

  const handleLearnMoreClick = (e) => {
    e.preventDefault();
    setIsVisible(false);

    if (onLearnMoreClick) {
      onLearnMoreClick();
    } else {
      const faqSection = document.getElementById("faq-section");
      if (faqSection) {
        faqSection.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <div
      className="score-tooltip"
      ref={tooltipRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button
        type="button"
        className="score-tooltip__trigger"
        onClick={handleToggle}
        aria-label="Commuter score information"
        aria-expanded={isVisible}
      >
        <img
          src="/assets/images/pdp/info.svg"
          alt=""
          className="score-tooltip__icon"
          width="16"
          height="16"
        />
      </button>

      {isVisible && (
        <div className="score-tooltip__content" role="tooltip">
          <p className="score-tooltip__text">
            {TOOLTIP_TEXT}{" "}
            {/* <a
              href="#faq-section"
              className="score-tooltip__learn-more"
              onClick={handleLearnMoreClick}
            >
              Learn More.
            </a> */}
          </p>
        </div>
      )}
    </div>
  );
};

export default ScoreTooltip;
